import { defaultCashAccounts } from './reporting';
import type { ReportAccount, ReportSnapshot } from './reporting';

export type LedgerScope = 'all' | 'selected' | 'cash' | 'receivables' | 'payables' | 'income' | 'expenses' | 'parent';
export type LedgerView = 'transaction' | 'account' | 'date';
export function ledgerAccountIds(accounts: ReportAccount[], scope: LedgerScope, chosen: string[], parent: string): Set<string> {
    if (scope === 'all') return new Set(accounts.map(a => a.id));
    if (scope === 'selected') return new Set(accounts.filter(a => chosen.includes(a.id)).map(a => a.id));
    if (scope === 'cash') return new Set(defaultCashAccounts(accounts));
    if (scope === 'parent') {
        const ids = new Set<string>(accounts.some(a => a.id === parent) ? [parent] : []);
        let changed = true;
        while (changed) { changed = false; for (const a of accounts) if (a.parentId && ids.has(a.parentId) && !ids.has(a.id)) { ids.add(a.id); changed = true; } }
        return ids;
    }
    return new Set(accounts.filter(a => scope === 'income' ? a.type === 'income' : scope === 'expenses' ? a.type === 'expense' : [a.subtype, a.system_key].includes(scope === 'receivables' ? 'accounts_receivable' : 'accounts_payable')).map(a => a.id));
}

export function ledgerView(data: ReportSnapshot, ids: Set<string>, start: string, end: string, view: LedgerView) {
    const accounts = data.accounts.filter(a => ids.has(a.id));
    const summaries = new Map(accounts.map(a => [a.id, { account: a, opening: 0, debit: 0, credit: 0, closing: 0 }]));
    const ordered = data.postings.filter(p => ids.has(p.accountId) && p.date <= end)
        .map((p, index) => ({ ...p, index })).sort((a, b) => a.date.localeCompare(b.date) || a.journalId.localeCompare(b.journalId) || a.index - b.index);
    const rows = [];
    for (const p of ordered) {
        const s = summaries.get(p.accountId)!;
        const amount = p.debit - p.credit;
        if (p.date < start) { s.opening += amount; s.closing += amount; continue; }
        s.debit += p.debit; s.credit += p.credit; s.closing += amount;
        rows.push({ ...p, account: s.account, running: s.closing });
    }
    if (view === 'account') rows.sort((a, b) => accounts.indexOf(a.account) - accounts.indexOf(b.account) || a.date.localeCompare(b.date) || a.journalId.localeCompare(b.journalId) || a.index - b.index);
    return { rows, summaries: [...summaries.values()], debit: rows.reduce((n, p) => n + p.debit, 0), credit: rows.reduce((n, p) => n + p.credit, 0) };
}
